@let columns = columnViewModelsSg();
@let visibleRows = visibleRowsSg();

<div class="atn-mosaic-tree-table">
  <div class="atn-mosaic-tree-table__main">
    @if (columns.length) {
      <div class="atn-mosaic-tree-table__content">
        <div class="atn-mosaic-tree-table__table">
          <div class="atn-mosaic-tree-table__header">
            @for (
              column of columns;
              track column.id;
              let isFirst = $first;
              let isLast = $last
            ) {
              <div
                class="atn-mosaic-tree-table__cell atn-mosaic-tree-table__header-cell"
                [class.atn-mosaic-tree-table__cell--primary]="isFirst"
              >
                <div
                  class="atn-mosaic-tree-table__cell-content"
                  [atnDsEllipsisTooltip]="column.name"
                  atnDsEllipsisTooltipPosition="above"
                >
                  {{ column.name }}
                </div>
                @if (!isLast) {
                  <div class="atn-mosaic-tree-table__header-divider">
                    <div
                      class="atn-mosaic-tree-table__header-divider-line"
                    ></div>
                  </div>
                }
              </div>
            }
          </div>

          <div class="atn-mosaic-tree-table__body">
            @if (visibleRows.length) {
              @for (entry of visibleRows; track entry.trackId) {
                <div class="atn-mosaic-tree-table__row">
                  @for (
                    cell of entry.cells;
                    track cell.columnId;
                    let isFirst = $first
                  ) {
                    <div
                      class="atn-mosaic-tree-table__cell"
                      [class.atn-mosaic-tree-table__cell--primary]="isFirst"
                    >
                      <div class="atn-mosaic-tree-table__cell-content">
                        @if (isFirst) {
                          <div
                            class="atn-mosaic-tree-table__primary-content"
                            [style.padding-left.px]="entry.indentPx"
                          >
                            @if (entry.hasChildren) {
                              <div class="atn-mosaic-tree-table__toggle-icon">
                                <i
                                  (click)="toggleRowClickHandler($event, entry)"
                                  class="atn-icon atn-blue"
                                  [class.atn-triangle-down]="entry.expanded"
                                  [class.atn-triangle-right]="!entry.expanded"
                                ></i>
                              </div>
                            }

                            @if (cell.value !== undefined) {
                              <atn-ds-value
                                class="atn-mosaic-tree-table__value"
                                [atnDsEllipsisTooltip]="cell.tooltip"
                                atnDsEllipsisTooltipPosition="above"
                                [value]="cell.value"
                                [valueInfo]="cell.valueInfo"
                              />
                            }
                          </div>
                        } @else {
                          @if (cell.value !== undefined) {
                            <atn-ds-value
                              class="atn-mosaic-tree-table__value"
                              [atnDsEllipsisTooltip]="cell.tooltip"
                              atnDsEllipsisTooltipPosition="above"
                              [value]="cell.value"
                              [valueInfo]="cell.valueInfo"
                            />
                          }
                        }
                      </div>
                    </div>
                  }
                </div>
              }
            } @else {
              <div class="atn-mosaic-tree-table__empty">No rows to display</div>
            }
          </div>
        </div>
      </div>
    } @else {
      <div class="atn-mosaic-tree-table__empty">No columns to display</div>
    }
  </div>
</div>
